"use client";

import { useSelector } from "react-redux";

import { ExternalButton } from "@components/shared/buttons";

import { useStoreContext } from "@components/store/provider";
import { useSendItemsContext } from "@contexts/send-items-context";

import { getIsLockerShop, getIsPricelessShop, getStore } from "@selectors/store";

import { isMobileDevice } from "@stadium/helpers/device";
import { CONTINUE_SHOPPING_TARGET } from "@constants/analytics/cart";
import { getMenuRoute } from "@constants/routes";
import styles from "./main.module.scss";

const DEFAULT_OBJ = {};

export const CartContinueShoppingCta = () => {
  const { storeBasePath, isNewSwagmagicHost } = useStoreContext();
  const { isSendToMyself } = useSendItemsContext();

  return (
    <div className={styles.backCtaBlock}>
      <ExternalButton
        href={getMenuRoute({ storeBasePath })}
        styleType="link"
        className={`${styles.continueLink} ${isNewSwagmagicHost ? styles.continueLinkV2 : ""}`}
        eventLocationAnalytics={{
          track: true,
          target: CONTINUE_SHOPPING_TARGET,
        }}
      >
        <i className={styles.iconArrowLeft} />{" "}
        {!isMobileDevice && <span>{isSendToMyself ? "Continue SHOPPING" : "Back"}</span>}
      </ExternalButton>
    </div>
  );
};

const CartWrapper = ({ children }) => {
  const store = useSelector(getStore);
  const isPricelessShop = useSelector(getIsPricelessShop);
  const isLockerShop = useSelector(getIsLockerShop);

  const { isKitShop } = store || DEFAULT_OBJ;

  const renderKitsWrapper = () => {
    return (
      <div className={styles.kitCartWrapper}>
        <div id="kit-cart-header-wrapper" className={styles.kitCartStickyHeader}></div>
        {children}
      </div>
    );
  };

  const renderCartListingWrapper = () => {
    return (
      <div
        className={`${styles.cartListingWrapper} ${
          isLockerShop || isPricelessShop ? styles.withCheckout : ""
        } ${isPricelessShop ? styles.isPricelessShop : ""}`}
      >
        <div id="cart-back-cta-container"></div>
        {children}
      </div>
    );
  };

  return (
    <>
      {isKitShop ? renderKitsWrapper() : renderCartListingWrapper()}{" "}
      <div id="cart-footer-container"></div>
    </>
  );
};

export default CartWrapper;
